module.exports = __webpack_public_path__ + "img/chanpin.6ae57ffb.png";